export * from './GlobalStorage';
export * from './GlobalStorage.interface';
